import { SurveyListPage } from './survey.list.page';

export default SurveyListPage;
